import Vue from 'vue'
import { QUOTE_FIRE_PARAM, QUOTE_FIRE_PARAM_GENERAL, QUOTE_FIRE_GENERAL, QUOTE_FIRE_PARAM_PLAN_LOADING, QUOTE_FIRE_PARAM_PLAN_SUCCESS, QUOTE_FIRE_PARAM_PLAN_FAIL, QUOTE_FIRE_PLANS, QUOTE_FIRE_RISK, QUOTE_FIRE_PAYMENT, QUOTE_FIRE_ADJ_CANCEL, QUOTE_FIRE_RECALCULATE_LOADING, QUOTE_FIRE_RECALCULATE_SUCCESS, QUOTE_FIRE_RECALCULATE_FAIL } from '@/store/types'
import { commitPkgPremium } from './quote'
import { formatServerTimeFormat } from '@/utils/date'

export const fire = {
  [QUOTE_FIRE_PARAM](state, data) {
    // Note: Key - ignoreValue is reserved
    if (data) {
      const formatData = data
      let ignoreValue = data.ignoreValue
      if (ignoreValue === undefined) {
        ignoreValue = false
      }
      Object.keys(formatData).forEach(function (key) {
        if (key !== 'ignoreValue') {
          const arr = formatData[key]
          if (arr) {
            if (Array.isArray(arr)) {
              // Make it so that its value - label (easier to search)
              arr.map(obj => {
                if (!ignoreValue) {
                  obj.label = obj.value + ' - ' + obj.label
                }
              })
            }
            // Initially was using the Object.assign below
            // But due to vue js reactive caveats, we will use Vue.set instead
            Vue.set(state.quotation.fireParam, key, arr)
          }
        }
      })
      // Object.assign(state.quotation.fireParam, formatData)
    }
  },
  [QUOTE_FIRE_PARAM_GENERAL](state) {
    state.quotation.fireParam.generalLoaded = true
  },
  [QUOTE_FIRE_GENERAL](state, data) {
    if (data) {
      state.quotation.commonForm.product = data.product
      state.quotation.commonForm.scheme = data.scheme
      state.quotation.commonForm.duration = data.duration
      state.quotation.commonForm.acceptDate = data.acceptDate
      state.quotation.commonForm.startDate = data.startDate
      state.quotation.commonForm.endDate = data.endDate
      state.quotation.commonForm.finInst = data.finInst
      state.quotation.commonForm.campaign = data.campaign
      state.quotation.commonForm.promotion = data.promotion
      Vue.set(state.quotation.commonForm, 'optCvr', data.optCvr)

      // Reset plans init (always get new plans after 1st screen)
      state.quotation.fireParam.plans.init = 0
    }
  },
  [QUOTE_FIRE_PARAM_PLAN_LOADING](state) {
    state.quotation.fireParam.plans.init = 0
    state.quotation.fireParam.plans.initErr = []
    state.quotation.fireParam.plans.limitsText = []
    state.quotation.fireParam.plans.plans = []
  },
  [QUOTE_FIRE_PARAM_PLAN_SUCCESS](state, data) {
    state.quotation.fireParam.plans.limitsText = data.limitsText
    state.quotation.fireParam.plans.plans = data.plans
    state.quotation.fireParam.plans.init = 1
    state.quotation.fireParam.plans.initErr = []
  },
  [QUOTE_FIRE_PARAM_PLAN_FAIL](state, data) {
    state.quotation.fireParam.plans.init = 2
    state.quotation.fireParam.plans.limitsText = []
    state.quotation.fireParam.plans.plans = []
    state.quotation.fireParam.plans.initErr = []
    if (data && data.length > 0) {
      state.quotation.fireParam.plans.initErr = data
    }
  },
  [QUOTE_FIRE_PLANS](state, data) {
    state.quotation.fireForm.planNo = data

    // Save premium info to commonInfo
    const plan = state.quotation.fireParam.plans.plans.find(x => x.planNo === data)
    if (plan && plan.premium) {
      commitPkgPremium(state, plan.premium)

      // Flag reviewPlan init as 1 (as it wont trigger recalculate when coming back from the next page)
      state.quotation.fireParam.reviewPlan.init = 1
    } else {
      commitPkgPremium(state, null)
    }
  },
  [QUOTE_FIRE_RISK](state, data) {
    if (data) {
      // Applicant Information
      const { applicant } = state.quotation.commonForm

      applicant.appIntStat = data.applicant.appIntStat
      applicant.appSalutation = data.applicant.appSalutation
      applicant.appName = data.applicant.appName
      applicant.appNricPassport = data.applicant.appNricPassport
      if (data.applicant.appDob) {
        applicant.appDob = formatServerTimeFormat(data.applicant.appDob)
      }
      applicant.appGender = data.applicant.appGender
      applicant.appOccupation = data.applicant.appOccupation
      applicant.appJointApplicant = data.applicant.appJointApplicant
      applicant.appEmail = data.applicant.appEmail
      applicant.appMobileNo = data.applicant.appMobileNo
      applicant.appTelNo1 = data.applicant.appTelNo1
      applicant.appTelNo2 = data.applicant.appTelNo2
      applicant.appPostalCode = data.applicant.appPostalCode
      applicant.appAdd1 = data.applicant.appAdd1
      applicant.appAdd2 = data.applicant.appAdd2
      applicant.appAdd3 = data.applicant.appAdd3
      applicant.appAdd4 = data.applicant.appAdd4
      applicant.mailAdd = data.applicant.mailAdd
      applicant.mailPostalCode = data.applicant.mailPostalCode
      applicant.mailAdd1 = data.applicant.mailAdd1
      applicant.mailAdd2 = data.applicant.mailAdd2
      applicant.mailAdd3 = data.applicant.mailAdd3
      applicant.mailAdd4 = data.applicant.mailAdd4
      applicant.coyName = data.applicant.coyName
      applicant.coyRocUen = data.applicant.coyRocUen
      applicant.coyNature = data.applicant.coyNature

      // Fire Risk
      const { fireForm } = state.quotation
      fireForm.riskAdd = data.riskAdd
      fireForm.riskAdd1 = data.riskAdd1
      fireForm.riskAdd2 = data.riskAdd2
      fireForm.riskAdd3 = data.riskAdd3
      fireForm.riskAdd4 = data.riskAdd4
      fireForm.riskPostalCode = data.riskPostalCode
      fireForm.constrnCls = data.constrnCls
      fireForm.occupancy = data.occupancy
    }
  },
  [QUOTE_FIRE_PAYMENT](state, data) {
    state.quotation.commonForm.paytMode = data.paytMode
    state.quotation.commonForm.paytCCNo = data.paytCCNo
    state.quotation.commonForm.paytCCName = data.paytCCName
    state.quotation.commonForm.paytCCType = data.paytCCType
    state.quotation.commonForm.paytCCExpMth = data.paytCCExpMth
    state.quotation.commonForm.paytCCExpYr = data.paytCCExpYr
    state.quotation.commonForm.paytCCCvv = data.paytCCCvv
  },
  [QUOTE_FIRE_ADJ_CANCEL](state) {
    // Reset Plan
    state.quotation.fireForm.planNo = null

    // Reset Adjustment
    state.quotation.commonForm.adjDiscount = null

    // Reset Premium
    commitPkgPremium(state, null)
  },
  [QUOTE_FIRE_RECALCULATE_LOADING](state) {
    state.quotation.fireParam.reviewPlan.init = 0
    state.quotation.fireParam.reviewPlan.initErr = []
  },
  [QUOTE_FIRE_RECALCULATE_SUCCESS](state, data) {
    state.quotation.fireParam.reviewPlan.init = 1
    state.quotation.fireParam.reviewPlan.initErr = []
    commitPkgPremium(state, data)
  },
  [QUOTE_FIRE_RECALCULATE_FAIL](state, data) {
    state.quotation.fireParam.reviewPlan.init = 2
    if (data && data.length > 0) {
      state.quotation.fireParam.reviewPlan.initErr = data
    }
    // Reset Premium
    commitPkgPremium(state, null)
  }
}
